export default "__VITE_ASSET__dh2DPAgM__"